import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getDataWAuth } from "../../../utils/api-service";
import { IB_BKP_GET_RATES } from "../../../constants/constant";


export const fetchBankRates = createAsyncThunk(
  "bkp/fetchBankRates",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getDataWAuth(IB_BKP_GET_RATES);
      return {
        bankRates: response.data.bankRatesDTOList,
        dates: response.data.fiscalDateDTOList,
        isLocked: response.data.fiscalDateDTOList[2].freeze,
        editableAndFreezable: response.data.editableAndFreezable
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


const bkpSlice = createSlice({
  name: "bkp",
  initialState: {
    bankRates: [],
    dates: [],
    isLocked: false,
    editableAndFreezable: false,
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    // Fetch Bank Rates
    builder
      .addCase(fetchBankRates.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchBankRates.fulfilled, (state, action) => {
        state.bankRates = action.payload.bankRates;
        state.dates = action.payload.dates;
        state.isLocked = action.payload.isLocked;
        state.editableAndFreezable = action.payload.editableAndFreezable;
        state.isLoading = false;
      })
      .addCase(fetchBankRates.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default bkpSlice.reducer;
